<script lang="ts">
  import { getQueryClientContext } from "@tanstack/svelte-query";
  import Dialog from "components/Common/Dialog.svelte";
  import { removeItemFromFolder } from "services/folders/api";
  import { notify } from "services/notifications";
  import { hideMimirSearchResult } from "state/queries/mimir";
  import { productFruitsInstance } from "../../services/productFruitsService";

  export let selectedImages: string[] = [];
  export let folderId: string;
  const queryClient = getQueryClientContext();

  async function onConfirm(): Promise<void> {
    try {
      for (const imageId of selectedImages) {
        await Promise.all([removeItemFromFolder(folderId, imageId)]);
      }

      notify(
        `${selectedImages.length} bilde${
          selectedImages.length > 1 ? "r" : ""
        } er fjernet fra samlingen`,
        "success",
        3000,
      );
      for (const imageId of selectedImages) {
        hideMimirSearchResult(queryClient, imageId);
      }
      $productFruitsInstance?.api.events.track(`image-removed-from-collection`);
    } catch (error) {
      console.error("Error removing from collection", error);
      notify(`Kunne ikke fjerne bildet fra samlingen`, "error", 5000);
    }
  }
</script>

<Dialog id="remove-from-collection-dialog" headerText={"Fjerne innhold"} confirmText={"Bekreft"} {onConfirm}>
  Er du sikker på at du vil fjerne {selectedImages.length} bilde{selectedImages.length > 1
    ? "r"
    : ""} fra samling?
</Dialog>
